module.exports = __webpack_public_path__ + "static/media/11.203707a6.jpg";